import { render } from "./Document.vue?vue&type=template&id=3011addd&scoped=true&ts=true"
import script from "./Document.vue?vue&type=script&lang=ts"
export * from "./Document.vue?vue&type=script&lang=ts"

import "./Document.vue?vue&type=style&index=0&id=3011addd&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3011addd"]])

export default __exports__